// extracted by mini-css-extract-plugin
export default {"infoMessage":"info-message_infoMessage__YfP6Z","exclamationIcon":"info-message_exclamationIcon__X58PA"};